// function clearInlineRestrictions(el) {
//   if (!el || !el.style) return;
//   el.style.removeProperty('clip-path');
//   el.style.removeProperty('contain-intrinsic-height');
//   el.style.removeProperty('content-visibility');
//   el.style.setProperty('height', 'auto', 'important');
//   el.style.setProperty('min-height', '0', 'important');
//   el.style.setProperty('max-height', 'none', 'important');
//   el.style.setProperty('overflow', 'visible', 'important');
//   el.style.setProperty('contain', 'none', 'important');
// }

// function fixOpenSubmenus() {
//   document.querySelectorAll('.menu-list__submenu[data-active]').forEach(function (submenu) {
//     clearInlineRestrictions(submenu);
//     submenu.style.setProperty('opacity', '1', 'important');
//     submenu.style.setProperty('visibility', 'visible', 'important');
//     submenu.style.setProperty('pointer-events', 'auto', 'important');
//     submenu.style.setProperty('position', 'absolute', 'important');
//     submenu.style.setProperty('top', '100%', 'important');
//     submenu.style.setProperty('left', '0', 'important');
//     submenu.style.setProperty('width', 'auto', 'important');
//     submenu.style.setProperty('min-width', '200px', 'important');
//     submenu.style.setProperty('max-width', '280px', 'important');

//     submenu.querySelectorAll('*').forEach(function (child) {
//       clearInlineRestrictions(child);
//     });

//     submenu.querySelectorAll('.mega-menu__column').forEach(function (col) {
//       col.style.setProperty('height', 'auto', 'important');
//       col.style.setProperty('min-height', '0', 'important');
//       col.style.setProperty('flex', 'none', 'important');
//       col.style.setProperty('align-items', 'flex-start', 'important');
//     });

//     submenu.querySelectorAll('.mega-menu__link').forEach(function (link) {
//       link.style.setProperty('display', 'block', 'important');
//       link.style.setProperty('color', '#000000', 'important');
//       link.style.setProperty('pointer-events', 'auto', 'important');
//       link.style.setProperty('padding', '6px 0', 'important');
//     });
//   });
// }

// function fixSubmenuWidth() {
//   document.querySelectorAll('[data-menu-grid-id]').forEach(function (grid) {
//     grid.style.setProperty('--menu-columns-desktop', '1', 'important');
//     grid.style.setProperty('--menu-columns-tablet', '1', 'important');
//   });

//   document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
//     megaMenu.style.setProperty('width', 'auto', 'important');
//     megaMenu.style.setProperty('max-width', '100%', 'important');
//     megaMenu.style.setProperty('margin', '0', 'important');
//     megaMenu.style.setProperty('padding', '0', 'important');
//   });

//   document.querySelectorAll('.mega-menu__list').forEach(function (list) {
//     list.style.setProperty('display', 'block', 'important');
//   });

//   fixOpenSubmenus();
// }

// document.addEventListener('DOMContentLoaded', fixSubmenuWidth);

// document.querySelectorAll('.menu-list__list-item').forEach(function (item) {
//   item.style.setProperty('position', 'relative', 'important');
//   item.addEventListener('pointerenter', function () {
//     setTimeout(fixOpenSubmenus, 0);
//     setTimeout(fixOpenSubmenus, 50);
//     setTimeout(fixOpenSubmenus, 150);
//     setTimeout(fixOpenSubmenus, 400);
//   });
// });

// const observer = new MutationObserver(function () {
//   fixSubmenuWidth();
// });
// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
//   attributes: true,
//   attributeFilter: ['style', 'class', 'data-active', 'aria-expanded']
// });


function buildCustomDropdown() {
  document.querySelectorAll('.menu-list__list-item').forEach(function (listItem) {
    if (listItem.dataset.customDropdownDone) return;

    var nativeSubmenu = listItem.querySelector('.menu-list__submenu');
    if (!nativeSubmenu) return;

    var links = nativeSubmenu.querySelectorAll('.mega-menu__link');
    if (!links.length) return;

    listItem.dataset.customDropdownDone = 'true';

    // Native submenu ko humesha ke liye chhupa dein
    nativeSubmenu.style.setProperty('display', 'none', 'important');

    // Naya custom dropdown banayein
    var customDropdown = document.createElement('div');
    customDropdown.className = 'custom-dropdown';

    links.forEach(function (link) {
      var newLink = document.createElement('a');
      newLink.href = link.getAttribute('href');
      newLink.className = 'custom-dropdown__link';
      newLink.textContent = link.textContent.trim();
      customDropdown.appendChild(newLink);
    });

    listItem.style.position = 'relative';
    listItem.appendChild(customDropdown);

    listItem.addEventListener('mouseenter', function () {
      customDropdown.classList.add('is-open');
    });
    listItem.addEventListener('mouseleave', function () {
      customDropdown.classList.remove('is-open');
    });
  });
}

document.addEventListener('DOMContentLoaded', buildCustomDropdown);

const observer = new MutationObserver(buildCustomDropdown);
observer.observe(document.body, { childList: true, subtree: true });